import { render, staticRenderFns } from "./VendorsProfileOverview.vue?vue&type=template&id=bae9f780&scoped=true"
import script from "./VendorsProfileOverview.vue?vue&type=script&lang=js"
export * from "./VendorsProfileOverview.vue?vue&type=script&lang=js"
import style0 from "./VendorsProfileOverview.vue?vue&type=style&index=0&id=bae9f780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae9f780",
  null
  
)

export default component.exports